import { HTTPError } from 'ky';

export class ChunkLoadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'ChunkLoadError';
  }
}
export class HTTPErrorWithInternalMessage extends HTTPError {
  internalMessage: string;

  constructor(
    response: Response,
    request: Request,
    options: HTTPError['options']
  ) {
    super(response, request, options);
    this.internalMessage = ''; // 将在 handleError 中被设置
  }

  static async fromError(
    error: HTTPError,
    message: string
  ): Promise<HTTPErrorWithInternalMessage> {
    const customError = new HTTPErrorWithInternalMessage(
      error.response,
      error.request,
      error.options
    );
    customError.internalMessage = message;
    return customError;
  }
}
